// stubbed for now
export const ELD_ROUTES = {
  callback: {
    /**
     * @example /integrations/keep-truckin/oauth-callback?code=ffna9safnasf&state=asfg0wmg
     */
    location: '/integrations/keep-truckin/oauth-callback',
  },
  connect: {
    location: '/integrations/keep-truckin/:carrierId/connect',
  },
  importTrucks: {
    location: '/integrations/keep-truckin/:carrierId/import',
  },
  success: {
    location: '/user/settings/integrations/success-route',
  },
  failure: {
    location: '/user/settings/integrations/failure-route',
  },
}

export const allEldRoutes = Object.values(ELD_ROUTES).map(({ location }) => location)
